interface FallbackSizesType {
  width: number
  height: number
}

export function isValidSizes(
  width: number | undefined | string,
  height: number | undefined | string,
  FallbackSizes: FallbackSizesType | null
) {
  if (typeof width === 'number' && typeof height === 'number') {
    return {
      width,
      height,
    }
  }

  if (
    FallbackSizes &&
    typeof FallbackSizes.width === 'number' &&
    typeof FallbackSizes.height === 'number'
  ) {
    return {
      width: FallbackSizes.width,
      height: FallbackSizes.height,
    }
  }

  return null
}
